export default {
  bd: 'buruburu-dobutsu@play.co',
  web: 'trembly@play.co',
};
